/*
 * layout
 */
import { useAuth, ProfileDropdown } from "@psychology/auth/client"
import { appConfig } from "@psychology/config"
import { useDevMode } from "@psychology/dev"
import { LanguageSelect } from "@psychology/intl"
import { ErrorBoundary, Footer, Navbar } from "@psychology/react-components"
import {
	getEnvDomainName,
	AppTitle,
	getPlatformMetadata,
} from "@psychology/utils"
import { Link } from "@tanstack/react-router"
import { BookMarked } from "lucide-react"
import type { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import { Sidebar } from "./components/sidebar/sidebar"
import { SidebarOptions } from "./components/sidebar/sidebar-options"
import { SidebarSheetMenu } from "./components/sidebar/sidebar-sheet-menu"
import { getSidebarMenuList } from "./config/sidebar"

type LayoutProps = {
	children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
	const { user } = useAuth()
	const { devMode } = useDevMode()
	const { t } = useTranslation()

	const enabledSidebar = !!getPlatformMetadata(user)

	return (
		<div className={"flex size-full flex-row"}>
			{enabledSidebar && (
				<>
					<Sidebar
						title={appConfig.brand.title}
						TitleIcon={<BookMarked className={"size-6"} />}
						// initialSidebarIsOpen={initialSidebarIsOpen}
						// bottomContent={
						// 	<PowerLogoutButton
						// 		className={"pt-2"}
						// 		initialSidebarIsOpen={initialSidebarIsOpen}
						// 	>
						// 		{t("SignOut")}
						// 	</PowerLogoutButton>
						// }
						key={user?.id}
					>
						<SidebarOptions
							user={user}
							devMode={devMode}
							getSidebarMenuList={getSidebarMenuList}
						/>
					</Sidebar>
				</>
			)}
			<div className={"flex size-full flex-col"}>
				<Navbar
					className={"transition-[width] duration-300 ease-in-out"}
					title={AppTitle}
					titleHref={"/"}
					Sidebar={
						enabledSidebar ? (
							<SidebarSheetMenu
								title={appConfig.brand.title}
								TitleIcon={<BookMarked className={"size-6"} />}
								// bottomContent={
								// 	<PowerLogoutButton className={"pt-2"}>
								// 		{t("SignOut")}
								// 	</PowerLogoutButton>
								// }
								key={user?.id}
							>
								<SidebarOptions
									user={user}
									devMode={devMode}
									getSidebarMenuList={getSidebarMenuList}
								/>
							</SidebarSheetMenu>
						) : undefined
					}
					RightSide={
						<ProfileDropdown
							user={user || undefined}
							devMode={devMode}
							registerUrl={"/auth?tab=register"}
							loginUrl={"/auth?tab=login"}
							logoutUrl={"/auth/logout"}
							accountUrl={"/auth/account"}
						/>
					}
				/>
				<main
					className={
						"relative flex-1 transition-[width] overflow-y-hidden duration-300 ease-in-out"
					}
				>
					<ErrorBoundary>{children}</ErrorBoundary>
				</main>
				<Footer
					copyright={"© 2026 Timeprox"}
					copyrightHref={getEnvDomainName("https://timeprox.com")}
					RightSide={<LanguageSelect />}
					devMode={devMode}
					whitelistPathnames={["/", "/about", "/auth", "/waitlist"]}
				>
					<Link className={"text-inherit"} to={"/"}>
						{t("nav.home")}
					</Link>
					<Link className={"text-inherit"} to={"/about"}>
						{t("nav.about")}
					</Link>
				</Footer>
			</div>
		</div>
	)
}
